<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'
             title="Cập nhật"
             type="orange"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model.trim="model.code"
               label="Mã vai trò"
               validate-rules="required"
               disabled=""
      />

      <c-input v-model.trim="model.description"
               label="Mô tả"
               validate-rules="required"
      />
    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        code: null,
        description: null,
      },
    }
  },
  methods: {
    open(id) {
      this.show = true;
      this.model = {
        id: null,
        code: null,
        description: null,
      }
      this.getData(id);
    },
    getData(id) {
      this.$http
          .get("cms/api/v1.0/admin/roles/" + id)
          .then(successRes => {
            let data = successRes.data;
            this.model.id = data.id;
            this.model.code = data.code;
            this.model.description = data.description;
          }, errorRes => {
            this.errorNotify(errorRes);
            this.$stopLoader();
          })
      ;
    },
    submit() {
      this.$showLoader();
      let data = {
        "description": this.model.description,
      }
      this.$http
          .put("/cms/api/v1.0/admin/roles/" + this.model.id, data)
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            // this.$error(errorRes.response.data.message);
            this.$stopLoader();
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>